import SurgicalOrderV2 from 'presentation/contexts/surgical-order-v2/surgical-order-v2-context'

export default function makeSurgicalOrderV2Store() {
  return new SurgicalOrderV2()
}
